'use strict';

var DelayActionMixin = require('../mixins/DelayActionMixin');

var DELAY_AFTER_RESIZE_EVENT = 1000;

/**
 * Maintains `offsetWidth` and `offsetHeight` in state.
 * When the window is resized, updates it after a short interval.
 */
var SizeMonitorMixin = {
  mixins: [DelayActionMixin],

  getInitialState: function () {
    return {
      offsetWidth: undefined,
      offsetHeight: undefined
    };
  },

  componentDidMount: function () {
    this._updateDimensions();
    window.addEventListener('resize', this._handleWindowResize);
  },

  componentDidUpdate: function () {
    if (!this.state.offsetWidth || !this.state.offsetHeight) {
      this._updateDimensions();
    }
  },

  componentWillUnmount: function () {
    window.removeEventListener('resize', this._handleWindowResize);
  },

  _handleWindowResize: function () {
    if (!this.isMounted()) {
      return;
    }

    this.scheduleAction(this._updateDimensions, DELAY_AFTER_RESIZE_EVENT);
  },

  _updateDimensions: function () {
    if (!this.isMounted()) {
      return;
    }

    var node = this.getDOMNode();
    if (!node) {
      return;
    }

    this.setState({
      offsetWidth: node.offsetWidth,
      offsetHeight: node.offsetHeight
    });
  }
};

module.exports = SizeMonitorMixin;


/** WEBPACK FOOTER **
 ** ./mixins/SizeMonitorMixin.js
 **/